export { default } from './Backdrop';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Backdrop/index.js
// module id = 110
// module chunks = 0